import { Form } from "antd";
import { useEffect } from "react";
import { rules } from "../../../siteData/rules";
import FilledButton from "../../../component/FilledButton";
import CustomTextEditor from "../../../component/CustomTextEditor";

const AddPostPop = ({ post, btnLoader, handleAddPost, handleChange, postData, setPostData, setFormRef }) => {
    const [form] = Form.useForm();
    form.setFieldsValue(postData);

    useEffect(() => {
        setFormRef(form);
    }, []);

    const myStyle = {
        maxWidth: '18.8rem',
        fontSize: '1.6rem',
        lineHeight: '1.9rem',
        letterSpacing: '.02em',
        color: '#000000',
    }

    return (
        <div className="modal_body">
            <div className="add_thought_leader1">
                <Form
                    form={form}
                    name="register"
                    onFinish={(e) => handleAddPost()}
                    onReset={() => setPostData({ ...postData, raw: '' })}
                    scrollToFirstError
                    className="attached_courses-add_skill"
                >
                    <h1 className="text_uppercase">Add a discussion Post</h1>
                    <div className="d_flex justify_content_between fullWidth mb_5">
                        <p style={myStyle}>{post.course_name}</p>
                    </div>
                    <Form.Item name="raw" rules={rules.post_message} className="form_group">
                        <CustomTextEditor name='raw' handleChange={handleChange} />
                    </Form.Item>

                    <div class="form_group form_footer d_flex_center">
                        <button type="reset" className="btn btn_gray">clear</button>
                        <FilledButton type="submit" loading={btnLoader} value={"submit"} className="btn btn_primary" />
                    </div>
                </Form>
            </div>
        </div>
    )
};

export default AddPostPop;